<template>
  <div
    data-ht-module="broken-cart-popup"
    class="Cart__BrokenPopup"
    :class="{
      'Cart__BrokenPopup--Active': isActive,
      'Cart__BrokenPopup--Hidden': hasClosed,
    }"
    color="night-sky-dark"
  >
    <Icon
      data-ht-element="broken-cart-popup-close"
      :icon="'close'"
      @click="hidePopup"
    />
    <p class="t4 Cart__BrokenPopup--Heading" data-color="night-sky-dark">
      {{ store.terms.broken_cart.title }}
    </p>
    <p class="p5 Cart__BrokenPopup--Copy" data-color="night-sky-dark">
      {{ store.terms.broken_cart.copy }}
    </p>

    <div class="Cart__BrokenPopup--Buttons">
      <a
        class="button button--secondary"
        href="/pages/cart-support"
        data-ht-element="broken-cart-popup-contact-support-cta"
      >
        {{ store.terms.broken_cart.button_1 }}
      </a>
      <button
        class="button button--primary"
        data-ht-element="broken-cart-popup-review-cart-cta"
        @click="hidePopup"
      >
        {{ store.terms.broken_cart.button_2 }}
      </button>
    </div>

    <label class="p5">
      <input
        data-ht-element="broken-cart-popup-checkbox"
        type="checkbox"
        name="BrokenCart_Popup"
        @change="toggleCookie"
      />
      <span class="BrokenCart_Popup--Disclaimer" data-color="night-sky-dark">{{
        store.terms.broken_cart.disclaimer
      }}</span>
    </label>
  </div>
</template>

<script setup>
import { useCartStore } from './Composables/Store';
import Cookies from 'js-cookie';
import { ref, computed, onMounted } from 'vue';
import Icon from '../Global/Icon.vue';

const hasClosed = ref(false);
const initialState = ref(false);
const hidePopup = () => {
  hasClosed.value = true;
};

const toggleCookie = (value) => {
  if (value.target.checked) {
    Cookies.set('_bl_hide_broken_cart_popup', true, {
      expires: 21,
    });
  } else {
    Cookies.remove('_bl_hide_broken_cart_popup', false);
  }
};
const store = useCartStore();

const isActive = computed(() =>
  initialState.value ? store.hasOrphanedBundleItems : false
);

onMounted(async () => {
  if (Cookies.get('_bl_hide_broken_cart_popup')) {
    hasClosed.value = true;
  }

  //if viewing on the cart page, initialize popup immediately if applicable and ignore overlay event listeners
  if (window.location.pathname == '/cart') {
    setTimeout(() => {
      initialState.value = true;
    }, 1000);
  } else {
    window.addEventListener('init-overlay', (e) => {
      if (e.detail == 'cart') {
        setTimeout(() => {
          initialState.value = true;
        }, 1000);
      }
    });
    window.addEventListener('close-overlay', (e) => {
      if (e.detail == 'cart') {
        if (!Cookies.get('_bl_hide_broken_cart_popup')) {
          hasClosed.value = false;
        }
      }
    });
  }
});
</script>
